SJ.ControlJoystick = {
    multiplier: 0.006,
    size: 300,
    position: {
        x: 0,
        y: 0
    },

    startPosition: {
        x: 0, 
        y: 0
    },

    updatePosition: () => {

        SJ.ControlJoystick.position = {
            x: (SJ.mouseScreenX - SJ.ControlJoystick.startPosition.x) * SJ.ControlJoystick.multiplier,
            y: (SJ.mouseScreenY - SJ.ControlJoystick.startPosition.y) * SJ.ControlJoystick.multiplier
        }
        
    },

    setStartPosition: () => {
        SJ.ControlJoystick.startPosition = {
            x: SJ.mouseScreenX,
            y: SJ.mouseScreenY
        }
    },

    onTouchStarted: () => {
        SJ.ControlJoystick.setStartPosition();
    },

    onTouchEnded: () => {
        SJ.ControlJoystick.position = {
			x: 0,
			y: 0
		}

		SJ.ControlJoystick.startPosition = {
			x: 0,
			y: 0
		}
    },

    draw: () => {
        return;
        if(SJ.ControlJoystick.startPosition.x != 0 && SJ.ControlJoystick.startPosition.y != 0){
            push();

                translate(SJ.ControlJoystick.startPosition.x, SJ.ControlJoystick.startPosition.y);
                stroke(255);
                strokeWeight(3);
                noFill();
                // circle(0, 0, SJ.ControlJoystick.size);
    
                fill(42, 50, 75);
                circle(0, 0, 30);

                // textSize(32);
                // noStroke();
                // text(SJ.ControlJoystick.position.y, 100, 100);
            pop();
        }
    }
}